// extracted by mini-css-extract-plugin
export default {"btop":"_9ad73d9ef3 _73f9fcca84 b174034061","icon":"_93bed855b0 _217995fe90","btoppink":"_960e87d406 de9dd4ec46"};